import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as api from '../services/api';
import LoadingSpinner from "../components/Favourites/LoadingSpinner";
import ItineraryItem from "../components/Favourites/ItineraryItem";
import ShareFavourites from "../components/Favourites/ShareFavourites";
import PrintFavourites from "../components/Favourites/PrintFavourites";
import { loadRecaptcha } from 'react-recaptcha-v3'
import FlashMessage from "../components/Favourites/FlashMessage";
import ExcursionItem from "../components/Favourites/ExcursionItem";
import translate from "../services/translation";

export class ManageFavouritesApp extends Component {

    LOCAL_STORAGE_KEY = 'kontiki_favourite_itineraries';
    LOCAL_STORAGE_KEY_EXCURSIONS = 'kontiki_favourite_excursions';

    static propTypes = {
        reCaptchaSiteKey: PropTypes.string,
        printBaseUrl: PropTypes.string,
        printUrl: PropTypes.string,
    };

    initialState = {
        favouriteItineraries: [],
        favouriteExcursions: [],
        loading: true,
        flashMessages: []
    };

    constructor(props) {
        super(props);
        this.state = this.initialState;
    }

    componentDidMount() {
        loadRecaptcha(this.props.reCaptchaSiteKey);
        const favouriteItineraries = JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_KEY));
        const favouriteExcursions = JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_KEY_EXCURSIONS));

        if (favouriteItineraries !== null) {
            if (Array.isArray(favouriteItineraries)) {
                this.fetchItineraries(favouriteItineraries);
            } else {
                localStorage.removeItem(this.LOCAL_STORAGE_KEY);
            }
        }

        if (favouriteExcursions !== null) {
            if (Array.isArray(favouriteExcursions)) {
                this.fetchExcursions(favouriteExcursions);
            } else {
                localStorage.removeItem(this.LOCAL_STORAGE_KEY_EXCURSIONS);
            }
        }
    }

    sendFavouritesEmail = (email, recaptchaToken, callBack) => {
        api.sendFavouritesEmail(this.state.favouriteItineraries.map(item => item.uid).join(','), this.state.favouriteExcursions.map(item => item.uid).join(','), email, recaptchaToken)
            .then(
                response => {
                    this.setState({flashMessages: [{level: 'ok', messageKey: 'ok'}]});
                    callBack();
                },
                error => {
                    console.log(error);
                    this.setState({flashMessages: [{level: 'error', messageKey: 'error'}]})
                }
            );
    };

    clearFlashMessages = () => {
        this.setState({flashMessages: []});
    };

    render() {
        const {favouriteItineraries, favouriteExcursions, loading, flashMessages} = this.state;
        const {reCaptchaSiteKey, printBaseUrl, printUrl} = this.props;

        return (
            <div>
                {favouriteItineraries &&
                    <div className='shareContainer'>
                        <ShareFavourites siteKey={reCaptchaSiteKey} sendFavouritesEmail={this.sendFavouritesEmail} clearFlashMessages={this.clearFlashMessages} shareButtonLabel={'itinerary_favourites.show_email_button'} />
                        <PrintFavourites
                            printBaseUrl={printBaseUrl}
                            printUrl={printUrl}
                            itineraryIds={favouriteItineraries.map(item => item.uid).join(',')}
                            excursionIds={favouriteExcursions.map(item => item.uid).join(',')}
                        />
                        <div className='flashMessageContainer'>
                            {flashMessages.map(flashMessage => <FlashMessage messageKey={flashMessage.messageKey} level={flashMessage.level} />)}
                        </div>
                    </div>
                }
                {loading && <LoadingSpinner />}

                {favouriteItineraries.length > 0 && <h2>{translate('favourite.itinerary.title')}</h2>}

                {favouriteItineraries && favouriteItineraries.map(item => {
                    return <ItineraryItem favouriteItem={item} key={item.uid} onRemove={this.removeFavourite} />
                })}

                {favouriteExcursions.length > 0 && <h2>{translate('favourite.excursion.title')}</h2>}

                {favouriteExcursions && favouriteExcursions.map(item => {
                    return <ExcursionItem favouriteItem={item} key={item.uid} onRemove={this.removeFavourite}/>
                })}
            </div>
        );
    }

    fetchItineraries = (itineraryUids) => {
        api.getItinerariesByIds(itineraryUids).then(response => {
            this.setState({favouriteItineraries: response.data, loading: false});
        })
    };

    fetchExcursions = (excursionUids) => {
        api.getExcursionsByIds(excursionUids).then(response => {
            this.setState({favouriteExcursions: response.data, loading: false});
        })
    };

    removeFavourite = (favouriteUid) => {
        const {favouriteItineraries, favouriteExcursions} = this.state;

        const newFavouriteItineraries = favouriteItineraries.filter(item => {
            return favouriteUid !== item.uid;
        });

        const newFavouriteExcursions = favouriteExcursions.filter(item => {
            return favouriteUid !== item.uid;
        });

        this.setState({favouriteItineraries: newFavouriteItineraries}, () => {
            const favouriteUids = JSON.stringify(newFavouriteItineraries.map(item => {
                return item.uid;
            }));
            localStorage.setItem(this.LOCAL_STORAGE_KEY, favouriteUids)
        });

        this.setState({favouriteExcursions: newFavouriteExcursions}, () => {
            const favouriteUids = JSON.stringify(newFavouriteExcursions.map(item => {
                return item.uid;
            }));
            localStorage.setItem(this.LOCAL_STORAGE_KEY_EXCURSIONS, favouriteUids)
        });
    }
}



// WEBPACK FOOTER //
// ./src/apps/ManageFavouritesApp.js